import { useTheme } from 'styled-components'

import { Breadcrumbs } from '@/components/Breadcrumbs'
import { useIsMobileXL } from '@/hooks/use-media-query'

import { config } from './config'
import { Wrapper, TextWrapper, Title, SideImage } from './styles'

const { title, image } = config

export function Header() {
  const { newColors } = useTheme()
  const isMobileXL = useIsMobileXL()

  return (
    <Wrapper>
      {!isMobileXL && <Breadcrumbs textColor={newColors.lightOrange} />}
      <TextWrapper>
        <Title as="h1">{title}</Title>
      </TextWrapper>
      <SideImage {...image} />
    </Wrapper>
  )
}
